window.addEventListener("DOMContentLoaded", function () {
  if (document.body.getAttribute('data-color-swatch-initialized')) {
    return;
  }
  document.body.setAttribute('data-color-swatch-initialized', 'true');

  window.cachedProductData = window.cachedProductData || {}



  function showSwatchLoading(swatch) {
    swatch.classList.add("loading")
    swatch.style.pointerEvents = "none"
  }

  function hideSwatchLoading(swatch) {
    swatch.classList.remove("loading")
    swatch.style.pointerEvents = ""
  }


  function updateSelectedColorName(colorName) {
    const colorNameDisplay = document.querySelector(".color-name-display")
    if (colorNameDisplay) {
      colorNameDisplay.textContent = colorName
    }
  }



  function getVariantUrl(variantId, productUrl) {
    const url = new URL(productUrl)
    url.searchParams.set("variant", variantId)
    return url.toString()
  }

  const pendingRequests = {}
  let latestRequestedVariantId = null

  // Fetches the full product page instead of using the Section Rendering API.
  // Section IDs are tied to the current page's template, so `?sections=` would
  // render the other colourway with *this* template's settings (e.g. keep the
  // "PRE-ORDER" button text) rather than the template assigned to that product.
  function fetchAndCacheProductData(variantId, productUrl) {
    if (window.cachedProductData[variantId]) {
      return Promise.resolve(window.cachedProductData[variantId])
    }

    if (pendingRequests[variantId]) {
      return pendingRequests[variantId]
    }

    pendingRequests[variantId] = fetch(getVariantUrl(variantId, productUrl))
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`)
        }
        return res.text()
      })
      .then((pageHtml) => {
        const dom = new DOMParser().parseFromString(pageHtml, "text/html")
        const section = dom.getElementById("main-product-section")
        const html = section ? section.outerHTML : null
        if (html) {
          window.cachedProductData[variantId] = html
        }
        return html
      })
      .catch((error) => {
        console.error("Error fetching product data:", error)
        return null
      })
      .finally(() => {
        delete pendingRequests[variantId]
      })

    return pendingRequests[variantId]
  }


  function updateProductSections(variantId, productUrl) {
    const mainSection = document.getElementById("main-product-section")
    if (!mainSection) {
      return
    }

    latestRequestedVariantId = variantId

    fetchAndCacheProductData(variantId, productUrl).then((html) => {
      // Ignore stale responses if another swatch was clicked in the meantime
      if (variantId !== latestRequestedVariantId) {
        return
      }

      if (html) {
        updateSectionWithHTML(html, variantId)
      } else {
        // Couldn't swap in place, so load the product page directly
        window.location.href = getVariantUrl(variantId, productUrl)
      }
    })
  }


  function updateSectionWithHTML(html, variantId) {
    const mainSection = document.getElementById("main-product-section")
    if (!mainSection || !html) {
      console.error("Cannot update section: missing cart form or HTML")
      return
    }


    try {
      const dom = new DOMParser().parseFromString(html, "text/html")
      const newSection = dom.getElementById("main-product-section")


      if (newSection) {
        const selectedSwatch = document.querySelector(
          '[data-color-swatch-box][data-selected="true"]'
        )
        const currentColorName = selectedSwatch
          ? selectedSwatch.getAttribute("data-color-name")
          : null

        const scrollY = window.scrollY

        // Keep section-level attributes (section ID, colour scheme, spacing) in sync with the new template
        Array.from(newSection.attributes).forEach(({ name, value }) => {
          mainSection.setAttribute(name, value)
        })

        // Update the entire cart form content
        mainSection.innerHTML = newSection.innerHTML

        window.scrollTo(0, scrollY)

        if (currentColorName) {
          updateSelectedColorName(currentColorName)
        }


        attachEventListeners()

        document.dispatchEvent(
          new CustomEvent("color:changed", {
            detail: { variantId },
          })
        )


      } else {
        throw new Error("New cart form not found in response")
      }
    } catch (error) {
      console.error("Error updating section:", error)
    }
  }

  // Function to attach event listeners
  function attachEventListeners() {
    const newColorSwatches = document.querySelectorAll(
      "[data-color-swatch-box]"
    )

    newColorSwatches.forEach(function (colorSwatch) {
      colorSwatch.addEventListener("mouseover", handleColorSwatchHover)
      colorSwatch.addEventListener("click", handleColorSwatchClick)
    })
  }

  // Function to handle color swatch hover (preloading)
  function handleColorSwatchHover(e) {
    const variantId = e.currentTarget.getAttribute("data-id")
    const productUrl = e.currentTarget.href

    if (variantId && productUrl) {
      // Only fetch and cache data, don't update content
      fetchAndCacheProductData(variantId, productUrl)
    }
  }

  // Function to handle color swatch click
  function handleColorSwatchClick(e) {
    e.preventDefault()

    const swatch = e.currentTarget
    const variantId = swatch.getAttribute("data-id")
    const productUrl = swatch.href
    const isAvailable = swatch.getAttribute("data-available") === "true"
    const colorName = swatch.getAttribute("data-color-name")



    // Don't proceed if no variant ID
    if (!variantId) {
      return
    }

    // Show loading state
    showSwatchLoading(swatch)

    // Update the URL with the new variant ID
    const url = new URL(productUrl)
    url.searchParams.set("variant", variantId)
    window.history.replaceState({}, "", url)

    // Update selected state immediately for better UX
    const container = swatch.closest("[data-color-swatch-metafield]")
    if (container) {
      const allSwatches = container.querySelectorAll("[data-color-swatch-box]")
      allSwatches.forEach((box) => {
        box.setAttribute("data-selected", "false")
        box.classList.remove("selected")
      })
    }

    swatch.setAttribute("data-selected", "true")
    swatch.classList.add("selected")

    updateSelectedColorName(colorName)

    updateProductSections(variantId, productUrl)




    setTimeout(() => {
      hideSwatchLoading(swatch)
    }, 500)
  }


  // Initial event listener attachment
  attachEventListeners()

  const selectedColorSwatch = document.querySelector('[data-color-swatch-box][data-selected="true"]')
  if (selectedColorSwatch) {
    updateSelectedColorName(selectedColorSwatch.getAttribute("data-color-name"))
  }

})